(() => {
  const fields = ['title', 'product_type', 'vendor', 'variants.title'];
  const stopwords = new Set('de het een en van voor met in op aan the a an and of for with in on'.split(' '));
  const words = value => String(value).toLocaleLowerCase().match(/[\p{L}\p{N}]+/gu) || [];
  const stem = word => {
    if (word.length > 4 && word.endsWith('en')) return word.slice(0, -2).replace(/([ln])\1$/, '$1');
    if (word.length > 4 && word.endsWith('s')) return word.slice(0, -1);
    return word;
  };
  let productTypes = [];
  try { productTypes = JSON.parse(document.getElementById('sa-search-product-types')?.textContent || '[]'); } catch (_) {}
  const vocabulary = [...new Set(productTypes.flatMap(words).map(stem))];
  // These cabinet families have products whose product type is empty or more general.
  const cabinets = 'kast boekenkast opbergkast vakkenkast klapkast schuifdeurkast roldeurkast garagekast garderobekast knutselkast muziekkast leidsterkast kijkkast vindselkast wetenschapperskast mandjeskast onderkast bovenkast opzetkast'.split(' ');
  const quote = value => JSON.stringify(value);
  const english = {
    cabinet: 'kast', cupboard: 'kast', bookcase: 'boekenkast', wardrobe: 'garderobekast',
    table: 'tafel', chair: 'stoel', bed: 'bed', puzzle: 'puzzel', book: 'boek',
    wooden: 'houten', wood: 'hout', felt: 'vilt', red: 'rood', blue: 'blauw',
    green: 'groen', white: 'wit', black: 'zwart', round: 'rond', adjustable: 'verstelbaar'
  };

  function build(value) {
    const term = String(value).trim();
    if (!term || term.length > 180 || /[:"()*]|\b(?:AND|OR|NOT)\b/.test(term)) return term;
    if (/^[a-z]{1,8}[-.]?\d[\da-z.-]*$/i.test(term)) return `(variants.sku:${quote(term)} OR title:${quote(term)})`;
    let tokens = [...new Set(words(term).filter(word => !stopwords.has(word)))];
    if (!tokens.length || tokens.length > 8 || tokens.some(word => word.length < 2)) return term;
    // Field queries use the Dutch catalog data. Preserve native English search
    // when we cannot map every word, instead of hiding translated products.
    if (document.documentElement?.lang?.startsWith('en')) {
      if (tokens.some(word => !english[word] && !english[stem(word)])) return term;
      tokens = tokens.map(word => english[word] || english[stem(word)]);
    }
    const prefixGroup = token => `(${fields.map(field => `${field}:${token}*`).join(' OR ')})`;
    const query = tokens.map(token => {
      const root = stem(token);
      const related = root.length >= 3 ? vocabulary.filter(word => word.endsWith(root)) : [];
      if (root === 'kast') related.push(...cabinets);
      if (!related.length) return prefixGroup(token);
      const roots = [...new Set([root, ...related])].slice(0, 30);
      const forms = [...new Set(roots.flatMap(word => [word, `${word}en`, `${word}s`, `${word}je`, `${word}jes`]))];
      const clauses = forms.flatMap(word => ['title', 'product_type'].map(field => `${field}:${quote(word)}`));
      clauses.push(`vendor:${quote(token)}`, `variants.title:${quote(token)}`);
      return `(${clauses.join(' OR ')})`;
    }).join(' AND ');
    return query.length <= 7000 ? query : tokens.map(prefixGroup).join(' AND ');
  }

  window.DenHartogSearchQuery = { build };
})();
